/**
 * Parent panel RBAC (Spatie permission names) synced from login / GET parent/auth/permissions.
 */
export function getParentPermissionsFromStorage() {
  try {
    const raw = localStorage.getItem("parent-permissions");
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function parentHasPermission(permission) {
  if (!permission || typeof permission !== "string") return false;
  return getParentPermissionsFromStorage().includes(permission);
}

export function parentHasAllPermissions(permissions) {
  if (!Array.isArray(permissions) || permissions.length === 0) return false;
  return permissions.every((p) => parentHasPermission(p));
}

export function parentHasAnyPermission(permissions) {
  if (!Array.isArray(permissions) || permissions.length === 0) return false;
  return permissions.some((p) => parentHasPermission(p));
}
